import { useEffect } from "react";

export const useScrollTop = () => {
	useEffect(() => {
		if (!window.location.hash) {
			window.scrollTo({ top: 0, behavior: "instant" });
		}
	}, []);
};
